import { render, staticRenderFns } from "./MultiQuestion.vue?vue&type=template&id=4b61c3e2&scoped=true"
import script from "./MultiQuestion.vue?vue&type=script&lang=js"
export * from "./MultiQuestion.vue?vue&type=script&lang=js"
import style0 from "./MultiQuestion.vue?vue&type=style&index=0&id=4b61c3e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b61c3e2",
  null
  
)

export default component.exports